import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
var BrandService = /** @class */ (function () {
    function BrandService(auth, appConstants, http) {
        this.auth = auth;
        this.appConstants = appConstants;
        this.http = http;
    }
    BrandService.prototype.getAllBrands = function () {
        var url = environment.apiBase + 'all_brands';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    BrandService.prototype.getBrand = function (brandId) {
        var url = environment.apiBase + ("brands/" + brandId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    BrandService.prototype.getBrandManagers = function () {
        var url = environment.apiBase + 'brandmanagers';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    BrandService.prototype.createBrand = function (body) {
        var url = environment.apiBase + 'brands';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    BrandService.prototype.updateBrand = function (body) {
        var url = environment.apiBase + ("brands/" + body.id);
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body, headers).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    return BrandService;
}());
export { BrandService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/brand.service.ts.pre-build-optimizer.js